import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DrawerHeaderProps } from "../types";

function DrawerHeader({ className, ...props }: DrawerHeaderProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div
      data-slot="drawer-header"
      className={cn(
        "grid gap-1.5 p-4 text-center sm:text-left",
        className,
        classes,
      )}
      {...native}
    />
  );
}

DrawerHeader.displayName = "Drawer.Header";

export default DrawerHeader;
